import React, {Component} from "react"
import PropTypes from "prop-types"

import Form from "@irati/ui/src/Form"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {Banner} from "@irati/ui/src/Layout"
import Loading from "@irati/ui/src/Loading"
import AnonymousProfilePicture from "@irati/ui/src/ProfilePicture/AnonymousProfilePicture"
import {setForgotPassword} from "@irati/auth/services/password"
import History from "@irati/utils/history"
import id from "@irati/utils/id"
import authentication from "@irati/auth"
import {Password} from "@irati-web/fields/user"
import session from "@irati/auth/services/session"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import SetPasswordError from "@irati/ui/src/SetPasswordError"
import userService from "@irati/identity/services/users"
import loginService from "@irati/auth/services/login"

import StyledCard from "./styled/ForgotPasswordCard"
import StyledHeader from "./styled/Header"
import ResetPasswordError from "../../components/ResetPasswordError"
import PasswordSavedModal from "../../components/PasswordSavedModal/PasswordSavedModal"
import LoginBlock from "../../components/LoginBlock"

export class ResetPassword extends Component {
  static propTypes = {
    formatMessage: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      password: null,
      confirm: null,
      saved: false,
      load: this.getSessionDate(),
      submit: null,
      postData: {}
    }
  }

  getSessionDate = () => {
    return session
      .getThenRemove(["uuid", "verificationCode"])
      .then((postData) => {
        // no user data so do not call user endpoint
        if (!postData.uuid) {
          return
        }
        return userService.unAuthedUser(postData.uuid).then(({email}) => {
          this.setState({postData: {...postData, email}})
        })
      })
      .catch(() => {
        /* no-op, fail silently */
      })
  }

  handleChange = (label, value) => {
    this.setState({
      [label]: value,
      submit: null
    })
  }

  handleSubmit = () => {
    const {password, postData} = this.state

    const {email, uuid: userId, verificationCode: confirmation} = postData

    const submit = setForgotPassword(userId, confirmation, password).then(() => {
      this.setState({saved: true})
      return loginService.login(authentication.unAuthedBusiness(), email, password).then(() => {
        // Set timeout is called so user has time to see the success message before they are redirected
        setTimeout(() => {
          History.replace({
            pathname: "/"
          })
        }, 3000)
      })
    })

    this.setState({submit})
  }

  render() {
    const {formatMessage} = this.props
    const {load, submit, confirm, password, postData} = this.state
    const {uuid, verificationCode, email} = postData
    /**  containers should force to init the idNamespace */
    const idNamespace = id("reset-password", this.props, {force: true})

    const missingData = !uuid || !verificationCode || !email

    return (
      <div id={idNamespace}>
        <Banner id={id("banner", idNamespace)} />
        <Loading load={load}>
          {missingData && <ResetPasswordError />}
          {!missingData && (
            <LoginBlock id={idNamespace}>
              <StyledCard id={id("card", idNamespace)} large>
                <AnonymousProfilePicture id={id("profile-pic", idNamespace)} />
                <StyledHeader id={id("title", idNamespace)}>Reset your password</StyledHeader>
                {this.state.saved ? (
                  <PasswordSavedModal id={idNamespace} />
                ) : (
                  <Form id={id("form", idNamespace)}>
                    <Password
                      id={id("field-password", idNamespace)}
                      label={formatMessage({id: "platform.resetPassword.fields.label"})}
                      placeholder={formatMessage({id: "platform.resetPassword.fields.placeholder"})}
                      value={password}
                      hint={formatMessage({id: "platform.password.hint"})}
                      onChange={(value) => this.handleChange("password", value)} />
                    <Password
                      id={id("field-password-confirm", idNamespace)}
                      name="confirmPassword"
                      label={formatMessage({id: "platform.resetPassword.fields.confirm.label"})}
                      placeholder={formatMessage({id: "platform.resetPassword.fields.confirm.placeholder"})}
                      value={confirm}
                      onChange={(value) => this.handleChange("confirm", value)}
                      passwordToMatch={this.state.password} />
                    <Loading load={submit} useLoader={false} />
                    <Loading load={submit} userLoader={false} Error={SetPasswordError} />
                    <ValidationButton
                      className="push--top"
                      primary
                      large
                      full
                      load={submit}
                      id={id("btn-submit", idNamespace)}
                      loading="Resetting password..."
                      onClick={this.handleSubmit}>
                      {this.state.isLoading ? (
                        <FormattedMessage id="platform.resetPassword.button.resetPassword" />
                      ) : (
                        <FormattedMessage id="platform.resetPassword.button.resettingPassword" />
                      )}
                    </ValidationButton>
                  </Form>
                )}
              </StyledCard>
            </LoginBlock>
          )}
        </Loading>
      </div>
    )
  }
}

export default injectIntl(ResetPassword)
